export const wordsList = {
    Carro: ["Motor", "Porta", "Capô", "Pneu", "Antena"],
    Fruta: ["Banana", "Maçã", "Pêra", "Mamão", "Laranja"],
    Corpo: ["Braço", "Perna", "Cérebro", "Pescoço", "Olhos"],
    Computador: ["Mouse", "Teclado", "Monitor", "Gabinete", "Mousepad"],
    Programação: ["jQuery", "Algoritmo", "Framework", "JavaScript", "React"],
    Alimento: ["Arroz", "Feijão", "Carne", "Leite", "Ovo"]
};